export interface EntityFollowUpSaveContext {
  action: any;
  componentData: any;
  responseValue: any;
  saveResponse: any;
  saveTemplate: any;
  selectedEntityKey: string | null;
}

export interface EntityFollowUpSaveHandler {
  followUpFunctionName: string;
  buildPayload?: (context: EntityFollowUpSaveContext) => any;
  // When true, skip the generic GenericSaveService primary call for this entity
  // and save directly via followUpFunctionName using the form data.
  skipGenericSave?: boolean;
}

function buildGenericSaveStyleFollowUpPayload(
  context: EntityFollowUpSaveContext,
  followUpFunctionName: string,
): any {
  const componentData = context.componentData || {};
  const template = context.saveTemplate && typeof context.saveTemplate === 'object'
    ? JSON.parse(JSON.stringify(context.saveTemplate))
    : {};
  const templateRequestData = template.requestData && typeof template.requestData === 'object'
    ? template.requestData
    : {};
  const version = template.version || context.action?.version || componentData?.version || '1.0';
  const requestData = {
    ...templateRequestData,
    entity: context.selectedEntityKey || templateRequestData.entity || '',
    ...(
      context.responseValue && typeof context.responseValue === 'object'
        ? context.responseValue
        : {}
    ),
  };

  if (Object.prototype.hasOwnProperty.call(requestData, 'value')) {
    delete requestData.value;
  }

  return {
    ...template,
    requestData,
    responseList: [],
    operation: null,
    functionName: template.functionName || context.action?.functionName || componentData?.functionName || 'GenericSaveService',
    entity: template.entity || componentData?.entity || 'product',
    workflowId: template.workflowId || componentData?.workflowId || 'UI',
    communicationType: template.communicationType || componentData?.communicationType || 'rest',
    version,
    endpoints: [
      {
        functionName: followUpFunctionName,
        version,
      },
    ],
  };
}

const ENTITY_FOLLOW_UP_SAVE_HANDLERS: Record<string, EntityFollowUpSaveHandler> = {
  cu_rer_engine_pricing: {
    followUpFunctionName: 'cu_ms_rer_engine_attributes_update',
    skipGenericSave: true,
  },
  cu_suggested_prices_rer_engine: {
    followUpFunctionName: 'cu_ms_rer_suggested_to_rer_engine',
    buildPayload: (context) => buildGenericSaveStyleFollowUpPayload(
      context,
      'cu_ms_rer_suggested_to_rer_engine',
    ),
  },
  // 045 - Configuration (entity machine name: "configuration"): reuses the RER
  // Suggested flow. On save this fires the generic GenericSaveService call first,
  // then the sequential follow-up below. Keyed on the lowercased entity `name`.
  configuration: {
    followUpFunctionName: 'cu_ms_rer_suggested_to_rer_engine',
    buildPayload: (context) => buildGenericSaveStyleFollowUpPayload(
      context,
      'cu_ms_rer_suggested_to_rer_engine',
    ),
  },
};

export function getEntityFollowUpSaveHandler(selectedEntityKey: string | null): EntityFollowUpSaveHandler | null {
  const normalizedEntityKey = String(selectedEntityKey || '').trim().toLowerCase();
  return ENTITY_FOLLOW_UP_SAVE_HANDLERS[normalizedEntityKey] || null;
}
